import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export function useOptimisticNavigation() {
  const navigate = useNavigate();
  const [isNavigating, setIsNavigating] = useState(false);
  
  const navigateWithFeedback = (path: string) => {
    setIsNavigating(true);
    // Instant visual feedback before route change
    requestAnimationFrame(() => {
      navigate(path);
      // Reset after route change
      setTimeout(() => setIsNavigating(false), 300);
    });
  };
  
  return { navigateWithFeedback, isNavigating };
}
